module.exports = __webpack_public_path__ + "img/default-bg-en.c391be7f.png";